import { Map } from 'immutable';

export const UPDATE_LOADER = 'modules/axp-peer-payments-pay-any-bank-root/UPDATE_LOADER';
export const UPDATE_PABA = 'modules/axp-peer-payments-pay-any-bank-root/UPDATE_PABA';
export const UPDATE_VERIFYPAYLOADDATA = 'modules/axp-peer-payments-pay-any-bank-root/UPDATE_VERIFYPAYLOADDATA';
export const TOGGLE_HOW_IT_WORKS = 'modules/axp-peer-payments-pay-any-bank-root/TOGGLE_HOW_IT_WORKS';
export const MANUAL_PAYMENT = 'modules/axp-peer-payments-pay-any-bank-root/MANUAL_PAYMENT';
export const UPDATE_PAYMENT_LINK = 'module/axp-peer-payments-pay-any-bank-root/UPDATE_PAYMENT_LINK';
export const MANUAL_CREATE_INSTRUMENT = 'modules/axp-peer-payments-pay-any-bank-root/MANUAL_CREATE_INSTRUMENT';
export const PLAID_CREATE_INSTRUMENT = 'modules/axp-peer-payments-pay-any-bank-root/PLAID_CREATE_INSTRUMENT';
/* eslint complexity: ["error", 20] */

const initialState = new Map({
  p2p: {
    loader: true,
    pabaObj: {
      token: '',
      nonce: '',
      type: '',
      stateId: '',
      status: '',
      wst: '',
      code: '',
      message: '',
    },
    verifyPayloadData: {},
    howItWorks: false,
    manualPayment: false,
    paymentLink: '',
    manualCreateInstrument: null,
    plaidCreateInstrument: null,
  },
});

export function rootReducer(state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_LOADER:
      return state.set('p2p', { ...state.get('p2p'), loader: payload });
    case UPDATE_PABA:
      return state.set('p2p', { ...state.get('p2p'), pabaObj: payload });
    case UPDATE_VERIFYPAYLOADDATA:
      return state.set('p2p', { ...state.get('p2p'), verifyPayloadData: payload });
    case TOGGLE_HOW_IT_WORKS:
      return state.set('p2p', { ...state.get('p2p'), howItWorks: payload });
    case MANUAL_PAYMENT:
      return state.set('p2p', { ...state.get('p2p'), manualPayment: payload });
    case UPDATE_PAYMENT_LINK:
      return state.set('p2p', { ...state.get('p2p'), paymentLink: payload });
    case MANUAL_CREATE_INSTRUMENT:
      return state.set('p2p', { ...state.get('p2p'), manualCreateInstrument: payload });
    case PLAID_CREATE_INSTRUMENT:
      return state.set('p2p', { ...state.get('p2p'), plaidCreateInstrument: payload });
    default:
      return state;
  }
}
